export default __webpack_public_path__ + "static/media/report-type-icon1.b2d3ac52.svg";